<template>
  <div class="alert">
    <div class="alert__linel"></div>
    <div class="alert__text">{{ data }}</div>
    <div class="alert__liner"></div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.alert > div {
  display: inline-block;
  line-height: 48px;
  vertical-align: middle;
}
@include b(alert) {
  height: 48px;
  text-align: center;
  background-image: url('../img/alert-bg.png');
  background-size: 100% 48px;
  margin-bottom: 10px;
  @include e(liner) {
    width: 57px;
    height: 1px;
    background-image: url('../img/line-right.png');
    background-size: 57px 1px;
    background-repeat: no-repeat;
  }
  @include e(linel) {
    width: 57px;
    height: 1px;
    background-image: url('../img/line-left.png');
    background-size: 57px 1px;
    background-repeat: no-repeat;
    // background:linear-gradient(-270deg,rgba(232,232,232,0) 0%,rgba(204,204,204,1) 100%);
  }
  @include e(text) {
    font-size: 14px;
    color: #f6a252;
    margin: 0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/DisContent.vue